// import * as dotenv from 'dotenv'
// dotenv.config().parsed
import { defineAsyncComponent } from 'vue'

export const CONFIG = {
  DEFAULT_GROUP: 'slot',
  SPEC_USER_DEFAULT_GROUP: 'hot',
  collapseStart: 300,
  COOKIES_OPTIONS: { path: '/' },
  COOKIES_OPTIONS_REMOVE: { path: '/' },
  SCROLL_ARROW: {
    RATIO: 1.5, // SCREEN SIZE * RATIO == SHOW BUTTON
  },
  API: {
    WS_TIMEOUT: 2000,
    TIMEOUT: 30000,
    API_BK_URL: process.env.API_BK_URL,
  },
  WS: {
    WS_INTERVAL_RECONNECT: 3000,
    PONG_TIMEOUT: 5000,
    PONG_INTERVAL: 20000,
  },
}

export const BASE_URL = process.env.BASE_URL || ''

export const AVAILABLE_LANG_LIST = process.env.LOCALES.split('|') || ['ru', 'en', 'kk', 'az', 'uk', 'uz', 'ky']

export const CACHE_API = {
  INFO: 30,
  MAIN_SLIDER: 30,
  GAME_GROUPS: 30,
  MANUFACTURERS_LIST: 30,
  GAMES: 30,
}

export const minBalanceForModalOnGame = {
  KZT: 30,
  UZS: 700,
  EUR: 0.1,
  USD: 0.1,
  GBP: 0.1,
  KGS: 5,
  RUB: 5,
  INR: 5,
  UAH: 3,
  AZN: 0.2,
}

export const HIDE_APPS_LINKS_BY_PLATFORM = new Set(['sultan'])
export const HIDE_SOCIAL_LINKS_BY_PLATFORM = new Set(['sultan'])

export const SOCIAL_LINKS = {
  FACEBOOK: process.env.SOCIAL_LINK_FACEBOOK,
  INSTAGRAM: process.env.SOCIAL_LINK_INSTAGRAM,
  INSTAGRAM_WORLD: process.env.SOCIAL_LINK_INSTAGRAM_WORLD || process.env.SOCIAL_LINK_INSTAGRAM,
  TG_BOTS: process.env.SOCIAL_LINK_TG_BOTS,
}

export const thumbStyle = {
  borderRadius: '8px',
  width: '8px',
  background: 'var(--cas-grey-1)',
  opacity: 0.8,
}

export const EVOLUTION_LIMITS_GROUPS = ['online']

export const HOT_SLIDERS = [
  {
    group: 'slot',
    subgroup: 'hot',
    title: 'slots',
    link: { name: 'GamesByGroup', params: { group: 'slot' } },
  },
  {
    group: 'online',
    subgroup: 'hot',
    title: 'live_casino',
    link: { name: 'GamesByGroup', params: { group: 'online' } },
  },
  {
    group: 'fast',
    subgroup: 'hot',
    title: 'instant',
    link: { name: 'GamesByGroup', params: { group: 'fast' } },
  },
  {
    group: 'slot',
    title: 'Drops & Wins',
    subgroup: 'drops_and_wins',
  },
  {
    group: 'slot',
    subgroup: 'buybonus',
    title: 'Bonus Buy',
  },
  {
    group: 'lottery',
    subgroup: 'hot',
    title: 'lottery',
    link: { name: 'GamesByGroup', params: { group: 'lottery' } },
  },
  {
    group: 'slot',
    subgroup: 'cashback',
    title: 'Cashback',
  },
  {
    group: 'new',
    title: 'new',
    link: { name: 'GamesByGroup', params: { group: 'new' } },
  },
]

export const getCashBoxComponent = () => {
  if (process.env.PLATFORM === 'olimp') {
    return defineAsyncComponent(() => import('components/modals/cashbox/olimp/CashBoxModal.vue'))
  }
  return defineAsyncComponent(() => import('components/modals/cashbox/olymp/CashBoxModal.vue'))
}

export const getAuthBySocialComponent = () => {
  if (process.env.PLATFORM === 'olimp') {
    return defineAsyncComponent(() => import('components/user/auth/olimp/AuthSocialPanel.vue'))
  }
  return defineAsyncComponent(() => import('components/user/auth/olymp/AuthSocialPanel.vue'))
}

// По какой-то причине если написать этот импорт в самом компоненте, то он закэшируется и не будет работать hot reload
export const getBonusModal = () => {
  return defineAsyncComponent(() => import('components/modals/GetBonusModal.vue'))
}

export const getActivateBonusModal = () => {
  return defineAsyncComponent(() => import('components/modals/ActivateBonusModal.vue'))
}

export const AVAILABLE_MODALS_BY_QUERY = {
  login: {
    componentName: () => defineAsyncComponent(() => import('components/modals/AuthModalNew.vue')),
    props: { tab: 'login' },
    authRequire: false,
  },
  reg: {
    componentName: () => defineAsyncComponent(() => import('components/modals/AuthModalNew.vue')),
    props: { tab: 'reg' },
    authRequire: false,
  },
  recovery: {
    componentName: () => defineAsyncComponent(() => import('components/modals/AuthModalNew.vue')),
    props: { startWithPassRecovery: true, tab: 'login' },
    authRequire: false,
  },
  cashbox: {
    componentName: () =>
      defineAsyncComponent(() => import(`components/modals/cashbox/${process.env.PLATFORM}/CashBoxModal.vue`)),
    authRequire: true,
  },
  cashback: {
    componentName: () => defineAsyncComponent(() => import('components/modals/CashBackModal.vue')),
    authRequire: true,
  },
  repeatTopUpModal: {
    componentName: () => defineAsyncComponent(() => import('components/modals/RepeatTopUpModal.vue')),
    authRequire: true,
  },
}

export const LOCATIONS_LIST = {
  ru: 'ru-RU',
  en: 'en-US',
  bn: 'bn-BD',
  uz: 'uz-UZ',
  ky: 'ky-KG',
  kk: 'kk-KZ',
}

export const LINK_INSIDE_PAYMENT_IDS = [272, 270, 269, 268, 267, 266]

export const ALLOW_MIRROR = {
  query: 'almirr',
  header: 'ALLOW-MIRROR',
  storage: localStorage,
}

export const LIST_OF_GET_PARAMS_TO_SAVE = {
  [ALLOW_MIRROR.query]: ALLOW_MIRROR.storage,
}

export const showBkBalance = process.env.PLATFORM === 'olimp' && !process.env.OWN_SPORT

export const OPEN_GAMES_IN_IFRAME_FOR_USERS = ['3295809']
